import { tryGetHostApi } from "./externalApi";
export async function getHostInstanceManagerApi(minVersion = 1, targetVersion = 1) {
    return (await tryGetHostApi("InstanceManager", minVersion, targetVersion));
}
